import React from "react";

export interface IconFileImportProps extends React.SVGProps<SVGSVGElement> {
  width?: number | string;
  height?: number | string;
  fill?: string;
}

export const IconFileImport: React.FC<IconFileImportProps> = ({
  width = 32,
  height = 32,
  fill = "#006231",
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.5999 3.19922C7.8349 3.19922 6.3999 4.63422 6.3999 6.39922V18.3992H15.5049L13.9549 16.8492C13.4849 16.3792 13.4849 15.6192 13.9549 15.1542C14.4249 14.6892 15.1849 14.6842 15.6499 15.1542L19.2499 18.7542C19.7199 19.2242 19.7199 19.9842 19.2499 20.4492L15.6499 24.0492C15.1799 24.5192 14.4199 24.5192 13.9549 24.0492C13.4899 23.5792 13.4849 22.8192 13.9549 22.3542L15.5049 20.8042H6.3999V25.6042C6.3999 27.3692 7.8349 28.8042 9.5999 28.8042H22.3999C24.1649 28.8042 25.5999 27.3692 25.5999 25.6042V11.7292C25.5999 10.8792 25.2649 10.0642 24.6649 9.46422L19.3349 4.13422C18.7349 3.53422 17.9249 3.19922 17.0749 3.19922H9.5999ZM22.6749 11.9992H17.9999C17.3349 11.9992 16.7999 11.4642 16.7999 10.7992V6.12422L22.6749 11.9992Z"
      fill={fill}
    />
  </svg>
);
